import Swiper from 'swiper/swiper-bundle';

// Initialize Swiper slider
new Swiper('.js-insulation-slider', {
	spaceBetween: 30,
	loop: true,
	navigation: {
		nextEl: '.insulation-next',
		prevEl: '.insulation-prev',
	},
	breakpoints: {
		320: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 2,
		},
		1280: {
			slidesPerView: 3,
		},
	},
});

const insulationSections = document.querySelectorAll('.insulation');

if (insulationSections.length > 0) {
	insulationSections.forEach((insulationSection) => {
		const insulationButtons = insulationSection.querySelectorAll('.insulation__checked');
		const insulationCards = insulationSection.querySelectorAll('.insulation__slide');

		if (insulationButtons.length > 0) {
			insulationButtons.forEach((buttons) => {
				const checkboxes = buttons.querySelectorAll('.insulation__check input[type="checkbox"]');

				const updateCardDisplay = () => {
					const checkedTypes = Array.from(checkboxes)
						.filter(cb => cb.checked)
						.map(cb => cb.getAttribute('data-type'));

					if (checkedTypes.length === 0) {
						// If no checkboxes are checked, show all cards
						insulationCards.forEach((card) => {
							card.style.display = 'block';
						});
					} else {
						// Show cards that match any of the checked types
						insulationCards.forEach((card) => {
							const cardTypes = card.getAttribute('data-type').split(',');
							const isVisible = checkedTypes.some(type => cardTypes.includes(type));
							card.style.display = isVisible ? 'block' : 'none';
						});
					}
				};

				checkboxes.forEach((checkbox) => {
					checkbox.addEventListener('click', updateCardDisplay);
				});

				// Initial call to set up the display based on initial checkbox states
				updateCardDisplay();
			});
		}
	});
}
